/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-10-16 16:02:11
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-10-20 09:14:11
 * @FilePath: \hlweb2.0\src\pages\AboutUs\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import "antd/dist/antd.css";
import Top from "../../components/common/Top";
import Footer from "../../components/common/Footer";
import FreeTrial from "../../components/FreeTrial";
import ContactModel from "../../components/common/ContactModel";
import Qualifications from "./Qualifications";
import AnchorPoint from "../../components/AnchorPoint";
import Banner from "./Banner";
import DigitalTechnology from "./DigitalTechnology";
import BriefIntroduction from "./BriefIntroduction";
import CoreBenefits from "./CoreBenefits";
import Culture from "./Culture";
import Develop from "./Develop";
import { Layout } from "antd";
import actionWays from "../../redux/actions";
import { adaptation } from "../../utils/adaptation";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../Solution/common/index.scss";
const { Content } = Layout;
class AboutUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicList: [],
      projectList: [],
      projectName: "",
      showScroll: false,
    };
  }
  componentDidMount = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation();
  };

  render() {
    return (
      <Layout>
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          <div style={{background:'#008ad4',height:'150px'}}></div>
          {/* 关于惠联 start */}
          <BriefIntroduction />
          {/* 关于惠联 end */}
          {/* 在线体验  start*/}
          {/* <FreeTrial /> */}
          {/* 在线体验  end*/}
          {/* banner图 start*/}
            <Banner />
          {/* banner图 end*/}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AboutUs));
